import { ConsumerHandshake } from '../Handshake';
import { AbstractConsumerEndpoint } from './AbstractEndpoint';
import { ConsumerChannel } from '../ConsumerChannel';

export class IFrameConsumerEndpoint extends AbstractConsumerEndpoint {
  static exposeAPI<TApi>(instance: TApi) {
    const consumer = new IFrameConsumerEndpoint();

    consumer.onConnect((port) => {
      const transport = new ConsumerChannel(port);
      transport.expose(instance);
    });
  }

  handshake = new ConsumerHandshake(
    (message) => {
      globalThis.parent.postMessage(message, '*');
    },
    (listener) => {
      globalThis.addEventListener('message', listener);
    },
  );
}
